import { z } from 'zod/v4';
import { EnabledPlatformFeatureSchema } from '../../../platform-features/index.js';
import { companySchema } from './company.js';

export const AdminCompanyGetParamsSchema = z.object({
  id: z.string().min(1, 'Company ID is required'),
});

export type AdminCompanyGetParams = z.infer<typeof AdminCompanyGetParamsSchema>;

export const AdminCompanyGetQuerySchema = z.object({
  /** true = look up a soft-removed company instead of an active one. */
  removed: z
    .union([z.boolean(), z.string()])
    .optional()
    .transform(v => v === true || v === 'true'),
});

export type AdminCompanyGetQuery = z.infer<typeof AdminCompanyGetQuerySchema>;

export const AdminCompanyDetailResponseSchema = companySchema.extend({
  enabledFeatures: z.array(EnabledPlatformFeatureSchema),
});

export type AdminCompanyDetail = z.infer<
  typeof AdminCompanyDetailResponseSchema
>;
